import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BonusGamePage from '../../pages/BonusGamePage';
import RewardsPage from '../../pages/RewardsPage';
import FaqPage from '../../pages/FAQPage';
import CitiesBalancePage from '../../pages/CitiesBalancePage';
import ScootersLockHistoryPage from '../../pages/ScootersLockHistoryPage';
import ZonesPage from '../../pages/ZonesPage';
import ScootersPage2 from '../../pages/ScootersPage2';
import TripsPage2 from '../../pages/TripsPage2';
import { selectAuth } from '../../redux/slices/authSlice';
import PromocodesPage from '../../pages/PromocodesPage';
import UsersPage from '../../pages/UsersPage';
import PushesPage from '../../pages/PushesPage';
import NoticesPage2 from '../../pages/NoticesPage2';
import NotesPage from '../../pages/NotesPage';
import SparePartsPage from '../../pages/SparePartsPage';
import WorkshopTasksPage from '../../pages/WorkshopTasksPage';
import DriverTasksPage from '../../pages/DriverTasksPage/DriverTasksPage';
import BatteriesPage from '../../pages/BatteriesPage/BatteriesPage';
import TariffsPage from '../../pages/TariffsPage';
import HistoryPage from '../../pages/HistoryPage';
import CitiesPage from '../../pages/CitiesPage';
import AdminsPage from '../../pages/AdminsPage';
import AdminRolesPage from '../../pages/AdminRolesPage';
import TabsPage from '../../pages/TabsPage/TabsPage';
import StatisticPage from '../../pages/StatisticPage/StatisticPage';
import { selectAdmins } from '../../redux/slices/adminsSlice';
import PaymentIcon from '@mui/icons-material/Payment';
import MapIcon from '@mui/icons-material/Map';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import GroupIcon from '@mui/icons-material/Group';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import {
  AddAlert,
  Announcement,
  History,
  LiveHelp,
  Payment,
  Room,
  Settings,
  SportsEsports,
  BarChart,
  LocationCity,
  Tab,
  StickyNote2,
  Reviews,
  ElectricScooter,
  DirectionsCar,
  BusinessCenter,
  Campaign,
  AdminPanelSettings,
  Tune,
  Build,
  Schedule,
  Layers,
  Place,
  Security,
  SearchOff,
  Inventory,
  Engineering,
  Category,
  Dashboard,
  BatteryChargingFull,
  Assignment,
  LocalParking,
  TravelExplore,
  SupportAgent,
  Hotel,
} from '@mui/icons-material';
import { checkPermission } from '../../resources/functions';
import NewsPage from '../../pages/NewsPage';
import TrackitPage from '../../pages/TrackitPage';
import SubscriptionPage from '../../pages/SubscriptionPage';
import FeedbacksPage from '../../pages/FeedbacksPage';
import WorkingHoursPage from '../../pages/WorkingHoursPage';
import ZoneManagementPage from '../../pages/ZoneManagementPage';
import MapMarkersPage from '../../pages/MapMarkersPage';
import LostScootersPage from '../../pages/LostScootersPage';
import ScooterTypesPage from '../../pages/ScooterTypesPage';
import ParkingsPage from '../../pages/ParkingsPage';
import TouristPlacesPage from '../../pages/TouristPlacesPage';
import TicketsPage from '../../pages/TicketsPage';
import RentalStatisticsPage from '../../pages/RentalStatisticsPage';
import HotelReportPage from '../../pages/HotelReportPage';

export interface Route {
  path: string;
  label?: string;
  code?: string;
  component?: (props: any) => JSX.Element | null;
  nested?: Route[];
  icon?: ReactElement;
}

const useRoutes = (): Route[] => {
  const auth = useSelector(selectAuth);
  const admin = useSelector(selectAdmins);
  const { t } = useTranslation();
  console.log('-=-= admin', admin);

  if (!auth.info) return [];

  const links: Route[] = [
    {
      label: t('nav.dashboard'),
      path: '/admin/stats',
      component: StatisticPage,
      code: 'statistics',
      icon: <Dashboard color='inherit' />
    },
    {
      label: t('nav.management'),
      path: '/control',
      icon: <BusinessCenter color='inherit' />,
      nested: [
        {
          label: t('nav.map'),
          icon: <MapIcon color='inherit' />,
          path: '/control',
          code: 'control',
          component: ZonesPage
        },
        {
          label: t('nav.scooters'),
          icon: <ElectricScooter color='inherit' />,
          path: '/scooters-2',
          code: 'scooters',
          component: ScootersPage2
        },
        {
          label: t('nav.trips'),
          icon: <DirectionsCar color='inherit' />,
          path: '/trips-2',
          code: 'contracts',
          component: TripsPage2
        },
        {
          label: t('nav.notices'),
          icon: <NotificationsActiveIcon color='inherit' />,
          path: '/notices-2',
          code: 'notices',
          component: NoticesPage2
        },
        {
          label: t('nav.lockHistory'),
          icon: <History color='inherit' />,
          path: '/scooters-lock-history',
          code: 'scooters-lock-history',
          component: ScootersLockHistoryPage
        },
        {
          label: t('nav.users'),
          icon: <GroupIcon color='inherit' />,
          path: '/users',
          code: 'users',
          component: UsersPage
        },
        {
          label: t('nav.feedbacks'),
          icon: <Reviews color='inherit' />,
          path: '/feedbacks',
          code: 'contractReviews',
          component: FeedbacksPage
        },
        {
          label: t('nav.trackit'),
          icon: <Room color='inherit' />,
          path: '/trackit',
          code: 'trackit',
          component: TrackitPage
        },
        {
          label: t('nav.lostScooters'),
          icon: <SearchOff color='inherit' />,
          path: '/lost-scooters',
          code: 'lost-scooters',
          component: LostScootersPage
        },
        {
          label: t('nav.tasks'),
          icon: <Assignment color='inherit' />,
          path: '/driver-tasks',
          code: 'driver_tasks',
          component: DriverTasksPage
        },
        {
          label: t('nav.supportTickets'),
          icon: <SupportAgent color='inherit' />,
          path: '/tickets',
          code: 'tickets',
          component: TicketsPage
        }
      ]
    },
    {
      label: t('nav.marketing'),
      path: '/promocodes',
      icon: <Campaign color='inherit' />,
      nested: [
        {
          label: t('nav.promocodes'),
          icon: <CardGiftcardIcon color='inherit' />,
          path: '/promocodes',
          code: 'bonuscodes',
          component: PromocodesPage
        },
        {
          label: t('nav.subscriptions'),
          icon: <CardMembershipIcon color='inherit' />,
          path: '/subscriptions',
          code: 'tariffs',
          component: SubscriptionPage
        },
        {
          label: t('nav.rewards'),
          icon: <SportsEsports color='inherit' />,
          path: '/rewards',
          code: 'rewards',
          component: RewardsPage
        },
        {
          label: t('nav.pushes'),
          icon: <AddAlert color='inherit' />,
          path: '/pushes',
          code: 'pushes',
          component: PushesPage
        },
        {
          label: t('nav.news'),
          icon: <Announcement color='inherit' />,
          path: '/news',
          code: 'news',
          component: NewsPage
        }
      ]
    },
    {
      label: t('nav.service'),
      path: '/notes',
      icon: <Build color='inherit' />,
      nested: [
        {
          label: t('nav.notes'),
          icon: <StickyNote2 color='inherit' />,
          path: '/notes',
          code: 'scooter_notes',
          component: NotesPage
        },
        {
          label: t('nav.spareParts'),
          icon: <Inventory color='inherit' />,
          path: '/spare-parts',
          code: 'spare_parts',
          component: SparePartsPage
        },
        {
          label: t('nav.workshopTasks'),
          icon: <Engineering color='inherit' />,
          path: '/workshop-tasks',
          code: 'workshop_tasks',
          component: WorkshopTasksPage
        },
        {
          label: t('nav.batteries'),
          icon: <BatteryChargingFull color='inherit' />,
          path: '/batteries',
          code: 'batteries',
          component: BatteriesPage
        }
      ]
    }
  ];

  const isSuperAdmin = auth.info.type === 'superAdmin';
  const isAminsCrud = checkPermission(admin.info?.tabs ?? [], 'admins crud');

  if (isSuperAdmin || isAminsCrud) {
    links.push({
      label: t('nav.administration'),
      path: '/admin/cities',
      icon: <AdminPanelSettings color='inherit' />,
      nested: [
        {
          label: t('nav.cities'),
          path: '/admin/cities',
          component: props => (
            <CitiesPage {...props} isSuperAdmin={isSuperAdmin} />
          ),
          icon: <LocationCity color='inherit' />
        },
        {
          label: t('nav.admins'),
          path: '/admin/admins',
          component: AdminsPage,
          icon: <GroupIcon color='inherit' />
        },
        ...(isSuperAdmin
          ? [
              {
                label: t('nav.adminRoles'),
                path: '/admin/roles',
                component: AdminRolesPage,
                icon: <Security color='inherit' />
              },
              {
                label: t('nav.tabs'),
                path: '/admin/tabs',
                component: TabsPage,
                icon: <Tab color='inherit' />
              }
            ]
          : []),
        {
          label: t('nav.transactions'),
          icon: <History color='inherit' />,
          path: '/history',
          code: 'history',
          component: HistoryPage
        },
        {
          label: t('nav.rentalStats'),
          icon: <BarChart color='inherit' />,
          path: '/admin/rental-statistics',
          code: 'statistics',
          component: RentalStatisticsPage
        }
      ]
    });
  } else {
    links.push({
      label: t('nav.selectCity'),
      path: '/cities',
      component: CitiesPage,
      icon: <Settings color='inherit' />
    });
  }

  links.push({
    label: t('nav.settings'),
    path: '/working-hours',
    icon: <Tune color='inherit' />,
    nested: [
      {
        label: t('nav.tariffs'),
        icon: <PaymentIcon color='inherit' />,
        code: 'tariffs',
        path: '/tariffs',
        component: TariffsPage
      },
      {
        label: t('nav.workingHours'),
        icon: <Schedule color='inherit' />,
        path: '/working-hours',
        code: 'working_hours',
        component: WorkingHoursPage
      },
      {
        label: t('nav.zonesEdit'),
        icon: <Layers color='inherit' />,
        path: '/zones-management',
        code: 'zone-edit',
        component: ZoneManagementPage
      },
      {
        label: t('nav.mapMarkers'),
        icon: <Place color='inherit' />,
        path: '/map-markers',
        code: 'map_markers',
        component: MapMarkersPage
      },
      {
        label: t('nav.hotelParkings'),
        icon: <LocalParking color='inherit' />,
        path: '/parkings',
        code: 'parkings',
        component: ParkingsPage
      },
      {
        label: t('nav.scooterTypes'),
        icon: <Category color='inherit' />,
        path: '/scooter-types',
        code: 'scooter_types',
        component: ScooterTypesPage
      },
      {
        label: t('nav.touristPlaces'),
        icon: <TravelExplore color='inherit' />,
        path: '/tourist-places',
        code: 'tourist_places',
        component: TouristPlacesPage
      },
      {
        label: t('nav.faq'),
        icon: <LiveHelp color='inherit' />,
        path: '/faq',
        code: 'faq',
        component: FaqPage
      }
    ]
  });

  links.push({
    label: t('nav.hotelReport'),
    path: '/hotel-report',
    component: HotelReportPage,
    code: 'view_management_company',
    icon: <Hotel color='inherit' />
  });

  if (auth.info.type !== 'superAdmin') {
    return links.filter(link => {
      if (link.nested && link.nested.length > 0) {
        const hasAccessToAnyNested = link.nested.some(nestedLink => {
          if (!nestedLink.code) return true;
          return checkPermission(admin.info?.tabs || [], nestedLink.code);
        });
        return hasAccessToAnyNested;
      }
      
      if (link.code) {
        return checkPermission(admin.info?.tabs || [], link.code);
      }
      
      return true;
    }).map(link => {
      if (link.nested && link.nested.length > 0) {
        return {
          ...link,
          nested: link.nested.filter(nestedLink => {
            if (!nestedLink.code) return true;
            return checkPermission(admin.info?.tabs || [], nestedLink.code);
          })
        };
      }
      return link;
    });
  }

  return links;
};

export default useRoutes;
